"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rules_api_1 = require("@gamepark/rules-api");
var assert_1 = __importDefault(require("assert"));
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var ActionFailed_1 = require("../../Actions/ActionFailed");
var GameNotificationsReceived_1 = require("../../Actions/GameNotificationsReceived");
var GameStateLoaded_1 = require("../../Actions/GameStateLoaded");
var SetAnimationsSpeed_1 = require("../../Actions/SetAnimationsSpeed");
var Failure_1 = __importDefault(require("../../Failure"));
var GameMode_1 = __importDefault(require("../../Types/GameMode"));
var MovePlayedNotification_1 = require("../../Types/MovePlayedNotification");
var MoveUndoneNotification_1 = require("../../Types/MoveUndoneNotification");
var ArrayUtil_1 = require("../../util/ArrayUtil");
var GameLocalAPI = /** @class */ (function () {
    function GameLocalAPI(context) {
        var _a, _b;
        this.lastActionId = 0;
        this.notificationsCount = 0;
        this.autoPlayersCounter = 0;
        this.aiProcessing = false;
        this.tutorialMovesToPlay = 0;
        Object.assign(context);
        this.game = context.game;
        this.Rules = context.Rules;
        this.RulesView = (_a = context.RulesView) !== null && _a !== void 0 ? _a : context.Rules;
        this.dummy = (_b = context.dummy) !== null && _b !== void 0 ? _b : this.createDummy(context.Rules);
        this.optionsSpec = context.optionsSpec;
        this.ai = context.ai || this.dummy;
        this.tutorial = context.tutorial;
    }
    GameLocalAPI.prototype.createDummy = function (Rules) {
        var dummy = new rules_api_1.Dummy(Rules);
        return function (state, playerId) { return dummy.getRandomMove(state, playerId); };
    };
    GameLocalAPI.prototype.init = function (dispatch) {
        var _this = this;
        this.dispatch = dispatch;
        var animationsSpeed = parseFloat(localStorage.getItem('animationsSpeed') || '1');
        this.dispatch((0, SetAnimationsSpeed_1.setAnimationsSpeed)(animationsSpeed));
        var data = this.initLocalStore();
        this.notificationsCount = data.actions.length;
        var dataToTransfer = {
            myPlayerId: data.playerId, setup: data.setup, state: data.state, notificationsCount: this.notificationsCount,
            players: data.players, options: { speed: rules_api_1.GameSpeed.Disabled, maxSpareTime: 0, maxExceedTime: 0 },
            mode: data.tutorial ? GameMode_1.default.TUTORIAL : GameMode_1.default.FRIENDLY, notificationsChannel: '', endDate: null, tournament: null
        };
        var initialGame = new this.Rules(data.setup);
        if ((0, rules_api_1.hasIncompleteInformation)(initialGame)) {
            dataToTransfer.setup = verifyNonMutation(function () { return (0, rules_api_1.getGameView)(initialGame, data.playerId); }, function () { return initialGame.state; }, 'getView must not change the game state');
        }
        var game = new this.Rules(data.state);
        if ((0, rules_api_1.hasIncompleteInformation)(game)) {
            dataToTransfer.state = verifyNonMutation(function () { return (0, rules_api_1.getGameView)(game, data.playerId); }, function () { return game.state; }, 'getView must not change the game state');
        }
        mimicDataTransfer(dataToTransfer).then(function (gameData) {
            dispatch((0, GameStateLoaded_1.gameStateLoaded)(gameData));
            mimicDataTransfer(_this.getNotifications(data)).then(function (notifications) { return dispatch((0, GameNotificationsReceived_1.gameNotificationsReceived)(notifications, 0, data.players)); });
        });
    };
    GameLocalAPI.prototype.initLocalStore = function () {
        var localStore = localStorage.getItem(this.game);
        if (localStore) {
            var data = JSON.parse(localStore);
            if (data.actions.length > 0 && !data.actions[0].id) {
                data.actions.forEach(function (action, index) {
                    if (!action.id)
                        action.id = index.toString();
                });
                localStorage.setItem(this.game, JSON.stringify(data));
            }
            if (data.actions.length > 0) {
                var lastActionId = parseInt(data.actions[data.actions.length - 1].id);
                if (!isNaN(lastActionId)) {
                    this.lastActionId = lastActionId;
                }
            }
            return data;
        }
        else {
            return this.tutorial ? this.newTutorial() : this.newGame();
        }
    };
    GameLocalAPI.prototype.getNotifications = function (data) {
        var game = new this.Rules(data.setup);
        if ((0, rules_api_1.hasIncompleteInformation)(game)) {
            var clientGame = new this.RulesView(JSON.parse(JSON.stringify((0, rules_api_1.getGameView)(game, data.playerId))));
            var notifications = [];
            var _loop_1 = function (action) {
                var moveView = verifyNonMutation(function () { return (0, rules_api_1.getMoveView)(game, JSON.parse(JSON.stringify(action.move)), data.playerId); }, function () { return game.state; }, 'getMoveView must not change the state of the game');
                clientGame.play(JSON.parse(JSON.stringify(moveView)));
                game.play(JSON.parse(JSON.stringify(action.move)));
                var consequences = [];
                var _loop_2 = function (move) {
                    var moveView_1 = verifyNonMutation(function () { return (0, rules_api_1.getMoveView)(game, JSON.parse(JSON.stringify(move)), data.playerId); }, function () { return game.state; }, 'getMoveView must not change the state of the game');
                    consequences.push(moveView_1);
                    clientGame.play(JSON.parse(JSON.stringify(moveView_1)));
                    game.play(JSON.parse(JSON.stringify(move)));
                };
                for (var _b = 0, _c = action.consequences; _b < _c.length; _b++) {
                    var move = _c[_b];
                    _loop_2(move);
                }
                notifications.push((0, MovePlayedNotification_1.movePlayedNotification)(__assign(__assign({}, action), { move: moveView, consequences: consequences })));
            };
            for (var _i = 0, _a = data.actions; _i < _a.length; _i++) {
                var action = _a[_i];
                _loop_1(action);
            }
            var serverGameView = JSON.parse(JSON.stringify((0, rules_api_1.getGameView)(game, data.playerId)));
            var clientGameView = JSON.parse(JSON.stringify(clientGame.state));
            if (!(0, fast_deep_equal_1.default)(serverGameView, clientGameView)) {
                console.error('Something is wrong with rules.getView or rules.getMoveView implementation: the view is not the same when moveViews are applied');
                console.error('Game view when moves are applied then getView is executed:', serverGameView);
                console.error('Game view when moves views are applied from the setup state:', clientGameView);
                console.error('If not fixed, there can be bugs especially with the UNDO features.');
            }
            return notifications;
        }
        else {
            return data.actions.map(function (action) { return (0, MovePlayedNotification_1.movePlayedNotification)(action); });
        }
    };
    GameLocalAPI.prototype.newTutorial = function () {
        if (!this.tutorial) {
            throw new Error('Pass a Tutorial in the options of createGameStore first');
        }
        var _a = this.tutorial.setupTutorial(), state = _a[0], playerIds = _a[1];
        return this.initGameStore(new this.Rules(state), playerIds, true); // TODO: tutorial extends Rules?
    };
    GameLocalAPI.prototype.newGame = function (arg) {
        if (arg === void 0) { arg = 2; }
        if (typeof arg === 'number') {
            var playerIds = (0, rules_api_1.providePlayerIds)(arg, this.optionsSpec);
            var options = (this.optionsSpec && (0, rules_api_1.isWithPlayerIdOptions)(this.optionsSpec) ? { players: playerIds.map(function (id) { return ({ id: id }); }) } : { players: arg });
            return this.initGameStore(new this.Rules(options), playerIds);
        }
        else {
            if (!arg.players) {
                arg.players = 2;
            }
            var playerIds = (0, rules_api_1.providePlayerIds)(arg.players, this.optionsSpec);
            if (Array.isArray(arg.players)) {
                for (var i = 0; i < arg.players.length; i++) {
                    arg.players[i].id = playerIds[i];
                }
            }
            else if (this.optionsSpec && (0, rules_api_1.isWithPlayerIdOptions)(this.optionsSpec)) {
                arg.players = playerIds.map(function (id) { return ({ id: id }); });
            }
            return this.initGameStore(new this.Rules(arg), playerIds);
        }
    };
    GameLocalAPI.prototype.initGameStore = function (game, playerIds, tutorial) {
        if (tutorial === void 0) { tutorial = false; }
        var playerId = playerIds[0];
        var players = playerIds.map(function (id) { return ({ id: id, quit: false }); });
        (0, rules_api_1.applyAutomaticMoves)(game);
        var setup = JSON.parse(JSON.stringify(game.state));
        var localStore = { players: players, setup: setup, state: game.state, actions: [], playerId: playerId, monkeyOpponents: tutorial, tutorial: tutorial };
        localStorage.setItem(this.game, JSON.stringify(localStore));
        return localStore;
    };
    GameLocalAPI.prototype.getLocalStore = function () {
        return JSON.parse(localStorage.getItem(this.game));
    };
    GameLocalAPI.prototype.play = function (move) {
        var _this = this;
        return mimicDataTransfer(move).then(function (move) {
            var localStore = _this.getLocalStore();
            var game = new _this.Rules(localStore.state); // TODO: this.tutorial?
            if (!verifyNonMutation(function () { return game.isLegalMove(localStore.playerId, move); }, function () { return game.state; }, 'isLegalMove and getLegalMoves must not change the game state')) {
                console.error('This move is not authorized right now: ' + JSON.stringify(move));
                var gameWithLegalMoves = game;
                if (gameWithLegalMoves.getLegalMoves) {
                    console.info('Legal moves are:', gameWithLegalMoves.getLegalMoves(localStore.playerId));
                }
                return;
            }
            if (localStore.tutorial && _this.tutorial) {
                var expectedMove = _this.tutorial.expectedMoves()[localStore.actions.length];
                if (expectedMove) {
                    var expectedMoves = Array.isArray(expectedMove) ? expectedMove : [expectedMove];
                    if (!expectedMoves.some(function (expectedMove) { return (0, fast_deep_equal_1.default)(move, expectedMove); })) {
                        _this.dispatch((0, ActionFailed_1.actionFailed)(Failure_1.default.TUTORIAL_MOVE_EXPECTED));
                        return;
                    }
                }
            }
            _this.autoPlayersCounter = 0;
            _this.playActions(localStore.playerId, [move]);
        }).catch(function (error) {
            console.error('The move could not be applied due to this error:', error);
            throw error;
        });
    };
    GameLocalAPI.prototype.playActions = function (playerId, moves) {
        var _a;
        var _this = this;
        var localStore = this.getLocalStore();
        var game = new this.Rules(localStore.state); // TODO: this.tutorial?
        var actions = [];
        var notifications = [];
        var id = (++this.lastActionId).toString();
        if ((0, rules_api_1.hasIncompleteInformation)(game)) {
            for (var _i = 0, moves_1 = moves; _i < moves_1.length; _i++) {
                var move = moves_1[_i];
                var _b = (0, rules_api_1.playActionWithViews)(game, move, playerId, [localStore.playerId], id), action = _b.action, views = _b.views;
                actions.push(action);
                var view = views.find(function (view) { return view.recipient === localStore.playerId; });
                if (view) {
                    notifications.push((0, MovePlayedNotification_1.movePlayedNotification)(view.action)); // TODO: MovePlayedNotification = Action
                }
            }
        }
        else {
            for (var _c = 0, moves_2 = moves; _c < moves_2.length; _c++) {
                var move = moves_2[_c];
                var action = (0, rules_api_1.playAction)(game, move, playerId, id);
                actions.push(action);
                notifications.push((0, MovePlayedNotification_1.movePlayedNotification)(action));
            }
        }
        mimicDataTransfer({ notifications: notifications, index: this.incrementNotificationsCount(notifications.length) }).then(function (data) {
            return _this.dispatch((0, GameNotificationsReceived_1.gameNotificationsReceived)(data.notifications, data.index, localStore.players));
        });
        (_a = localStore.actions).push.apply(_a, actions);
        localStorage.setItem(this.game, JSON.stringify(localStore));
        setTimeout(function () { return _this.runAutoPlayers(); }, 100 + Math.random() * 100);
    };
    GameLocalAPI.prototype.incrementNotificationsCount = function (quantity) {
        if (quantity === void 0) { quantity = 1; }
        var previousValue = this.notificationsCount;
        this.notificationsCount += quantity;
        return previousValue;
    };
    GameLocalAPI.prototype.undo = function (arg, ignoreRules) {
        var _this = this;
        if (arg === void 0) { arg = 1; }
        if (typeof arg === 'string') {
            var localStore_1 = this.getLocalStore();
            var index = (0, ArrayUtil_1.findLastIndex)(localStore_1.actions, function (action) { return action.id === arg; });
            var action = localStore_1.actions[index];
            if (!ignoreRules) {
                var game_1 = new this.Rules(localStore_1.state);
                if (!(0, rules_api_1.hasUndo)(game_1))
                    return console.error('This game does not have UNDO feature');
                if (!game_1.canUndo(action, localStore_1.actions.slice(index + 1)))
                    return console.error('Trying to UNDO a move while it is forbidden');
            }
            localStore_1.actions.splice(index, 1);
            var game = new this.Rules(JSON.parse(JSON.stringify(localStore_1.setup)));
            (0, rules_api_1.replayActions)(game, localStore_1.actions);
            localStore_1.state = game.state;
            localStorage.setItem(this.game, JSON.stringify(localStore_1));
            mimicDataTransfer({ notification: (0, MoveUndoneNotification_1.moveUndoneNotification)(action, index), index: this.incrementNotificationsCount() }).then(function (data) {
                return _this.dispatch((0, GameNotificationsReceived_1.gameNotificationsReceived)([data.notification], data.index, localStore_1.players));
            });
        }
        else if (arg > 0) {
            var actions = this.getLocalStore().actions;
            if (!actions.length)
                return console.warn('Cannot undo, no actions were played yet');
            this.undo(actions[actions.length - 1].id, true);
        }
    };
    GameLocalAPI.prototype.startMonkeyOpponents = function () {
        var localStore = this.getLocalStore();
        localStore.monkeyOpponents = true;
        localStorage.setItem(this.game, JSON.stringify(localStore));
        this.autoPlayersCounter = 0;
        this.runAutoPlayers();
    };
    GameLocalAPI.prototype.stopMonkeyOpponents = function () {
        var localStore = this.getLocalStore();
        localStore.monkeyOpponents = false;
        localStorage.setItem(this.game, JSON.stringify(localStore));
    };
    GameLocalAPI.prototype.runAutoPlayers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localStore, game, nextExpectedMove, expectedMoves, expectedMove_1, player, player, moves;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.autoPlayersCounter > 100) {
                            console.warn('The automatic players played 100 times. There might be an infinite loop, stopping now.');
                            return [2 /*return*/];
                        }
                        localStore = this.getLocalStore();
                        game = new this.Rules(localStore.state);
                        if (game.isOver()) {
                            console.info('Game is over');
                            return [2 /*return*/];
                        }
                        if (localStore.tutorial && this.tutorial) {
                            if (!this.tutorialMovesToPlay)
                                return [2 /*return*/];
                            nextExpectedMove = this.tutorial.expectedMoves()[localStore.actions.length];
                            if (nextExpectedMove) {
                                expectedMoves = Array.isArray(nextExpectedMove) ? nextExpectedMove : [nextExpectedMove];
                                if (expectedMoves.some(function (expectedMove) { return game.isLegalMove(localStore.playerId, expectedMove); })) {
                                    if (this.tutorialMovesToPlay !== Infinity) {
                                        this.tutorialMovesToPlay = 0;
                                    }
                                    return [2 /*return*/]; // Player turn
                                }
                                expectedMove_1 = expectedMoves[0];
                                player = localStore.players.find(function (player) { return game.isLegalMove(player.id, expectedMove_1); });
                                if (player) {
                                    this.tutorialMovesToPlay--;
                                    return [2 /*return*/, this.playActions(player.id, [expectedMove_1])];
                                }
                                else {
                                    console.error('Tutorial expects a move that no player can play: ', expectedMove_1);
                                }
                            }
                        }
                        if (!(localStore.monkeyOpponents && !this.aiProcessing)) return [3 /*break*/, 3];
                        player = localStore.players.find(function (player) { return player.id !== localStore.playerId && game.isTurnToPlay(player.id); });
                        if (!player) return [3 /*break*/, 2];
                        this.aiProcessing = true;
                        return [4 /*yield*/, this.ai(game.state, player.id, localStore.actions)];
                    case 1:
                        moves = _a.sent();
                        this.aiProcessing = false;
                        if (moves.length) {
                            this.playActions(player.id, moves);
                            this.autoPlayersCounter++;
                        }
                        else {
                            console.error('An AI is active but did not return any move to play!');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        if (localStore.playerId === undefined || !game.isTurnToPlay(localStore.playerId)) {
                            console.error('Game is not over but there is no active player!');
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GameLocalAPI.prototype.setPlayerName = function (name, playerId) {
        var localStore = this.getLocalStore();
        var player = localStore.players.find(function (player) { return player.id === (playerId || localStore.playerId); });
        if (!player) {
            throw new Error('Player not found');
        }
        player.name = name;
        localStorage.setItem(this.game, JSON.stringify(localStore));
    };
    GameLocalAPI.prototype.setAnimationsSpeed = function (speed) {
        if (speed === void 0) { speed = 1; }
        this.dispatch((0, SetAnimationsSpeed_1.setAnimationsSpeed)(speed));
        localStorage.setItem('animationsSpeed', speed.toString());
    };
    GameLocalAPI.prototype.eject = function () {
        // Eject feature is not yet available in development mode, and makes no sense in tutorial mode
    };
    GameLocalAPI.prototype.giveUp = function () {
        // Leaving is not yet available in development mode, and makes no sense in tutorial mode
    };
    GameLocalAPI.prototype.playTutorialMoves = function (quantity) {
        var _this = this;
        if (quantity) {
            this.tutorialMovesToPlay += quantity;
            this.autoPlayersCounter = 0;
            setTimeout(function () { return _this.runAutoPlayers(); }, 100 + Math.random() * 100);
        }
        else {
            this.tutorialMovesToPlay = 0;
        }
    };
    return GameLocalAPI;
}());
exports.default = GameLocalAPI;
function mimicDataTransfer(data, duration) {
    if (duration === void 0) { duration = 100; }
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(data ? JSON.parse(JSON.stringify(data)) : undefined); }, duration); });
}
function verifyNonMutation(operation, getState, message) {
    var initialState = JSON.stringify(getState());
    var result = operation();
    var finalState = JSON.stringify(getState());
    (0, assert_1.default)(initialState === finalState, message);
    return result;
}
